/* eslint-disable arrow-parens */
// initial state
const state = {
  loading: false,
  showImage: false,
  imageIndex: 0,
};

// getters
const getters = {
  loading: (currentState) => currentState.loading,
  showImage: (currentState) => currentState.showImage,
  imageIndex: (currentState) => currentState.imageIndex,
};

// actions
const actions = {
  showLoader({ commit }) {
    commit('setLoading', { loading: true });
  },
  hideLoader({ commit }) {
    commit('setLoading', { loading: false });
  },
  showImage({ commit }, { index }) {
    commit('setShowImage', { showImage: true, imageIndex: index });
  },
  hideImage({ commit }) {
    commit('setShowImage', { showImage: false, imageIndex: 0 });
  },
};

// mutations
const mutations = {
  setLoading(currentState, { loading }) {
    currentState.loading = loading;
  },
  setShowImage(currentState, { showImage, imageIndex }) {
    currentState.showImage = showImage;
    currentState.imageIndex = imageIndex;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/general.js